import type { DateString } from "types/api";
import type { Image } from "types/image";
import type { TaskPriority } from "types/task";

export enum MaintenanceTaskStatus {
  JobLogged = "job_logged",
  QuotesRequested = "quotes_requested",
  QuotesReceived = "quotes_received",
  QuotesApproved = "quotes_approved",
  QuotesIssued = "quotes_issued",
  WorkOrderIssued = "work_order_issued",
  WorkOrderAssigned = "work_order_assigned",
  WorkFinished = "work_finished",
}

export type MaintenanceTask = {
  id: string;
  summary: string;
  description: string | null;
  status_id: MaintenanceTaskStatus;
  priority_id: TaskPriority;
  work_assigned_to: string;
  access_provided_by?: string;
  reported_date?: DateString;
  closed_at?: DateString;
  images?: Image[];
  updated_at: DateString;
};
